import { useTranslation } from 'next-i18next';
import styles from '@features/cart/components/CartProductDescription/CartProductDescription.styles';
import useInflectedTranslation from '@hooks/useInflectedTranslation';
type PropsType = {
  productName: string;
  productTypeName: string;
  productDescription: string;
  quantity?: number | null;
  quantityType: string;
};
const CartProductDescription = ({
  productName,
  productTypeName,
  productDescription,
  quantity = null,
  quantityType
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const {
    getInflectedTranslation
  } = useInflectedTranslation();
  const title = quantityType === 'package' ? `${quantity} ${getInflectedTranslation(quantity || 1, 'pack')}` : t(`${quantity === 1 ? 'cart.quantityPluralSimple_one' : 'cart.quantityPluralSimple_other'}`, {
    quantity
  });
  return <div sx={styles.productDescriptionContainer}>
      <div sx={styles.productName} data-cy="CartProductName" title={productName}>
        {productName}
      </div>
      <div sx={styles.productNameType} data-cy="CartProductType" title={productTypeName}>
        {productTypeName}
      </div>
      {quantity && <div sx={styles.productNameType} data-cy="CartProductDescription" title={title}>
          {title}
        </div>}
      <div sx={styles.productDescription} data-cy="CartProductDescription" title={productDescription}>
        {productDescription}
      </div>
    </div>;
};
export default CartProductDescription;